import {resaleWatcher} from './resale/resale.effect';
import {accountingWatcher} from './saga/accountings.effects';
import {addCropWatcher} from './saga/addCrop.effects';
import {addCycleActivityDataSaga} from './saga/cycleActivitySaga';
import {addEquipmentSaga} from './saga/equipmentSaga';
import {
  getExpenseDataSaga,
  addExpenseDataSaga,
} from './saga/expenseSaga.effects';
import {
  addFarmDataSaga,
  getFarmDataSaga,
  updateDigiDiaryTnCSaga,
} from './saga/farmSaga';
import {
  setHomePageView,
  updatePopupSeenWatcher,
} from './saga/homeSetUp.effects';
import {addIncomeSaga} from './saga/incomeSaga';
import {machineHealthWatcher} from './saga/machineHealth.effects';
import {loadMyFarmView} from './saga/myFarm.effects';
import {loadOffers, authenticateNonMfaUser} from './saga/offers.effects';
import {updateCropDetailsWatcher} from './saga/updateCrop.effects';
import {addYieldSaga} from './saga/yieldSaga';

import {spawn} from 'redux-saga/effects';

export function* rootSaga() {
  yield spawn(resaleWatcher);
  yield spawn(addFarmDataSaga);
  yield spawn(getExpenseDataSaga);
  yield spawn(updateCropDetailsWatcher);
  yield spawn(addExpenseDataSaga);
  yield spawn(addEquipmentSaga);
  yield spawn(loadMyFarmView);
  yield spawn(addCropWatcher);
  yield spawn(setHomePageView);
  yield spawn(addCycleActivityDataSaga);
  yield spawn(addYieldSaga);
  yield spawn(addIncomeSaga);
  yield spawn(getFarmDataSaga);
  yield spawn(updateDigiDiaryTnCSaga);
  yield spawn(loadOffers);
  yield spawn(authenticateNonMfaUser);
  yield spawn(updatePopupSeenWatcher);
  yield spawn(accountingWatcher);
  yield spawn(machineHealthWatcher);
}
